export default __webpack_public_path__ + "static/media/cc-agent-3.7036347c.webp";